// Copyright (c) StrangeBee 2024

import React from 'react';
import { ReactElement } from 'react';
import { ImageForm } from './Image/ImageForm';
import { TextForm as TextFormComponent } from './Text/TextForm';
import { TableForm } from './Table/TableForm';
import { ReportTemplateWidgetType } from '../ReportTemplateManage';
import { ListForm } from './List/ListForm';

export const formMap: Record<
    ReportTemplateWidgetType,
    | ((props: {
          onFinish: (values: any) => void;
          onCancel: () => void;
          defaultValues: any;
          key: string;
          reportTemplateId: string;
      }) => ReactElement)
    | null
> = {
    text: (props) => <TextFormComponent {...props} />,
    image: (props) => <ImageForm {...props} />,
    table: (props) => <TableForm {...props} />,
    list: (props) => <ListForm {...props} />,
};
export const TextForm = TextFormComponent;
